import { menuItemType } from "../components/selectBox";

// 언어팩을 받아서 감지 종류 옵션 반환
export const getEventOptions = (t: any): menuItemType[] => [
  { value: 0, title: t.control.all },
  { value: 2, title: t.control.vehicleRolloverEvent },
  { value: 3, title: t.control.dangerousDrivingEvent },
  { value: 5, title: t.control.engineAbandonmentEvent },
  { value: 6, title: t.control.areaExitEvent },
  { value: 8, title: t.control.batteryLowEvent },
  // { value: 9, title: t.control.dangerousAreaEntryEvent },
];

// 언어팩을 받아서 기기 종류 옵션 반환 (전체 포함)
export const getMobileOptions = (t: any): menuItemType[] => [
  { value: -1, title: t.control.all },
  { value: 1, title: t.control.tractor },
  { value: 2, title: t.control.speedSprayer },
  { value: 3, title: t.control.fourWheelMotorcycle },
  { value: 4, title: t.control.twoWheelMotorcycle },
  { value: 5, title: t.control.oneTonTruck },
  { value: 6, title: t.control.walkingManagement },
  { value: 7, title: t.control.ridingManagement },
  { value: 8, title: t.control.agriculturalHighWorkVehicle },
  { value: 9, title: t.control.agriculturalTransportVehicle },
  { value: 10, title: t.control.agriculturalLoader },
  { value: 11, title: t.control.ridingWeedCutter },
  { value: 12, title: t.control.ridingWeedRemover },
  { value: 13, title: t.control.ridingTransplanter },
  { value: 14, title: t.control.fertilizerSpreader },
  { value: 15, title: t.control.pesticideSpreader },
  { value: 16, title: t.control.combine },
  { value: 17, title: t.control.excavator },
  { value: 18, title: t.control.cultivator },
  { value: 19, title: t.control.branchCrusher },
  { value: 0, title: t.control.etc },
];

// 기기 종류 옵션 (전체 없음) - 하위 호환성 유지
export const mobileOptions = [
  { value: 1, title: "트랙터" },
  { value: 2, title: "스피드스프레이어" },
  { value: 3, title: "사륜오토바이" },
  { value: 4, title: "이륜오토바이" },
  { value: 5, title: "1톤 트럭" },
  { value: 6, title: "보행관리기" },
  { value: 7, title: "승용관리기" },
  { value: 8, title: "농업용고소작업차" },
  { value: 9, title: "농업용운반차" },
  { value: 10, title: "농업용로더" },
  { value: 11, title: "승용예초기" },
  { value: 12, title: "승용제초기" },
  { value: 13, title: "승용이앙기" },
  { value: 14, title: "퇴비살포기" },
  { value: 15, title: "농약살포기" },
  { value: 16, title: "콤바인" },
  { value: 17, title: "굴삭기" },
  { value: 18, title: "경운기" },
  { value: 19, title: "잔가지파쇄기" },
  { value: 0, title: "기타" },
];

// 하위 호환성을 위한 기존 상수들 (deprecated - getEventOptions, getMobileOptions 사용 권장)
export const MOBILE_OPTIONS: menuItemType[] = [
  { value: -1, title: "전체" },
  { value: 1, title: "트랙터" },
  { value: 2, title: "스피드스프레이어" },
  { value: 3, title: "사륜오토바이" },
  { value: 4, title: "이륜오토바이" },
  { value: 5, title: "1톤 트럭" },
  { value: 6, title: "보행관리기" },
  { value: 7, title: "승용관리기" },
  { value: 8, title: "농업용고소작업차" },
  { value: 9, title: "농업용운반차" },
  { value: 10, title: "농업용로더" },
  { value: 11, title: "승용예초기" },
  { value: 12, title: "승용제초기" },
  { value: 13, title: "승용이앙기" },
  { value: 14, title: "퇴비살포기" },
  { value: 15, title: "농약살포기" },
  { value: 16, title: "콤바인" },
  { value: 17, title: "굴삭기" },
  { value: 18, title: "경운기" },
  { value: 19, title: "잔가지파쇄기" },
  { value: 0, title: "기타" },
];

export const LIMIT_OPTIONS: menuItemType[] = [
  { value: 10, title: "10" },
  { value: 20, title: "20" },
  { value: 50, title: "50" },
  { value: 100, title: "100" },
];

export const REG_OPTIONS: menuItemType[] = [
  { value: 0, title: "전체" },
  { value: 1, title: "기동리" },
  { value: 2, title: "석산리" },
  { value: 3, title: "신기리" },
  { value: 4, title: "금음리" },
];

export const EVENT_OPTIONS: menuItemType[] = [
  { value: 0, title: "전체" },
  { value: 2, title: "차량전복" },
  { value: 3, title: "위험운전" },
  { value: 5, title: "시동방치" },
  { value: 6, title: "사용지역이탈" },
  { value: 8, title: "배터리부족" },
  // { value: 9, title: "위험지역진입" },
];

export const HEADER_ITEMS = [
  { title: "사고 관제", to: "/"/*"/control"*/ },
  // { title: "감지내역 통계", to: "/stastics" },
  { title: "통계", to: "/stastics" },
  { title: "농기계 관리", to: "/mobile-list" },
  { title: "감지내역 조회", to: "/detect-list" },
  { title: "공지사항", to: "/notice" },
];
